import * as fetchApi from '@/config/fetchApi.js'
import * as constants from '@/config/constants.js'

export const unitCoordinates = (filter) => fetchApi.post(constants.ENDPOINT_UNIT_COORDINATES, filter)
export const clientCoordinates = (filter) => fetchApi.post(constants.ENDPOINT_CLIENT_COORDINATES, filter)
export const clientGeoStatus = (filter) => fetchApi.post(constants.ENDPOINT_GEO_STATUS, filter)
